module.exports = __webpack_public_path__ + "img/Stylized_knife.02473522.png";